import { Inject } from '../../../Application';
import { Constants, Order } from '../../../Contract';
import { Commands } from '../../../UI';
var ActionWorker = (function () {
    function ActionWorker(inject) {
        if (inject === void 0) { inject = null; }
        this.inject = inject;
        this.inject = inject || Inject.Instance;
        this.invoker = this.inject.resolve(Constants.Invoker);
        this.commandFactory = this.inject.resolve(Constants.CommandFactory);
    }
    ActionWorker.prototype.process = function (response) {
        var _this = this;
        if (response.actions) {
            var focusArray_1 = [];
            response.actions.forEach(function (c) {
                if (c.Name === Commands.ChangeFocusControlCommand) {
                    focusArray_1.push(c);
                }
                else {
                    c['id'] = c.Name;
                    _this.invoker.invoke(_this.commandFactory.create(c));
                }
            });
            for (var i = focusArray_1.length - 1; i >= 0; i--) {
                focusArray_1[i]['id'] = focusArray_1[i].Name;
                this.invoker.invoke(this.commandFactory.create(focusArray_1[i]));
            }
        }
    };
    Object.defineProperty(ActionWorker.prototype, "Order", {
        get: function () {
            return Order.POST;
        },
        enumerable: false,
        configurable: true
    });
    return ActionWorker;
}());
export { ActionWorker };
